// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__T1B2N","actions":"GroupTable_actions__o306f","deleteModalFooter":"GroupTable_deleteModalFooter__13uSz"};